import React from 'react';
import { ViewState } from '../types';

interface PolicyPageProps {
  type: ViewState;
}

const PolicyPage: React.FC<PolicyPageProps> = ({ type }) => {
  const isPrivacy = type === 'privacy';
  const title = isPrivacy ? '개인정보처리방침' : '서비스 이용 약관';

  return (
    <div className="pt-32 pb-24 px-4 bg-[#FAF7F2] min-h-screen">
      <div className="max-w-4xl mx-auto">
        <h1 className="text-3xl font-black text-slate-900 mb-8">{title}</h1>
        <div className="bg-white border border-[#F2ECE4] rounded-3xl p-8 md:p-12 text-slate-600 leading-relaxed shadow-sm">
          {isPrivacy ? (
            <div className="space-y-6">
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">1. 수집 항목</h2>
                <p>성명, 이메일, 휴대전화번호, 로그인 ID, 비밀번호, 서비스 이용 기록, 접속 로그, 쿠키, 접속 IP 정보 등</p>
              </section>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">2. 수집 목적</h2>
                <p>회원 관리, 서비스 제공 및 계약 이행, 신규 서비스 개발 및 마케팅 활용</p>
              </section>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">3. 보유 및 이용 기간</h2>
                <p>회원 탈퇴 시까지 (단, 관계 법령에 따라 보존할 필요가 있는 경우 해당 기간까지 보관)</p>
              </section>
              <section className="pt-4 border-t border-[#F2ECE4]">
                <h2 className="text-lg font-bold text-slate-800 mb-3">4. 개인정보 보호책임자</h2>
                <p>[성함/직책] : 김도약 / 대표이사</p>
                <p>[연락처/이메일] : sumingim707@gmail.com</p>
              </section>
            </div>
          ) : (
            <div className="space-y-6">
              <p className="font-medium text-slate-500 mb-6">이 약관은 서비스 이용자의 권리와 의무를 규정합니다.</p>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">제1조 (목적)</h2>
                <p>본 약관은 TOEFL 30 JUMP가 운영하는 사이트에서 제공하는 인터넷 관련 서비스의 이용 및 서비스 이용자의 권리, 의무 및 책임 사항을 규정함을 목적으로 합니다.</p>
              </section>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">제2조 (회원가입)</h2>
                <p>이용자는 회사가 정한 양식에 따라 회원정보를 기입한 후 이 약관에 동의함으로써 회원가입을 신청합니다.</p>
              </section>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">제3조 (서비스 중단)</h2>
                <p>회사는 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신의 두절 등의 사유가 발생한 경우에는 서비스의 제공을 일시적으로 중단할 수 있습니다.</p>
              </section>
              <section>
                <h2 className="text-lg font-bold text-slate-800 mb-3">제4조 (회원의 의무)</h2>
                <p>회원은 타인의 정보 도용, 회사가 게시한 정보의 변경, 회사가 정한 정보 이외의 정보(컴퓨터 프로그램 등)의 송신 또는 게시를 하여서는 안 됩니다.</p>
              </section>
            </div>
          )}
        </div>
        <div className="mt-10">
          <a href="/" className="text-pink-300 font-bold hover:text-pink-400 transition-colors flex items-center">
             <svg className="w-5 h-5 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
             </svg>
             홈으로 돌아가기
          </a>
        </div>
      </div>
    </div>
  );
}; export default PolicyPage;